import React from "react";
import { Slide } from "@material-ui/core";

export const TransitionUp = React.forwardRef((props, ref) => <Slide ref={ref} direction="up" {...props} />);
export const TransitionDown = React.forwardRef((props, ref) => <Slide ref={ref} direction="down" {...props} />);
